// extracted by mini-css-extract-plugin
export default {"container":"ButtonsCard_container__-WPMt","addButton":"ButtonsCard_addButton__aty0p","editBtn":"ButtonsCard_editBtn__DA04-"};